import http from "../plugins/axios";
import { AxiosError } from "axios";
import { AvatarCredentials } from "./account";
import { TeamModel } from "./track";

export interface UpdateTeamForm {
  teamName: string;
  schoolName: string;
  region: string;
  openSource: string;
}

export type ApplicationStatus =
  | "waiting"
  | "canceled"
  | "approved"
  | "rejected";
export type ValidateApplicationStatus = "approved" | "rejected";

export interface TeamApplication {
  id: number;
  user: number;
  team: number;
  status: ApplicationStatus;
}

export function getTeam(
  token: string,
  contestId: number,
  trackId: number,
  teamId: number
): Promise<TeamModel> {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/competition/${contestId}/track/${trackId}/team/${teamId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data as TeamModel);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.info||error.response.data;
          return reject(message);
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function newTeam(
  token: string,
  contestId: number,
  trackId: number,
  teamName: string
): Promise<number> {
  return new Promise((resolve, reject) => {
    http
      .post(
        `/api/competition/${contestId}/track/${trackId}/team`,
        { teamName,
          openSource:true
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        return resolve(response.data.Identity as number);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.info||error.response.data;
          return reject(message);
          if (status === 401) return reject("token-invalid");
          if (status === 403) return reject("unjoined-track");
          if (status === 409) return reject("joined-team");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function updateTeam(
  token: string,
  contestId: number,
  trackId: number,
  teamId: number,
  form: UpdateTeamForm
): Promise<void> {
  return new Promise((resolve, reject) => {
    http
      .put(
        `/api/competition/${contestId}/track/${trackId}/team/${teamId}`,
        form,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        return resolve();
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.info||error.response.data;
          return reject(message);
          if (status === 401) return reject("token-invalid");
          if (status === 403) return reject("unjoined-track");
          if (status === 409) return reject("joined-team");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function deleteTeam(
  token: string,
  contestId: number,
  trackId: number,
  teamId: number
): Promise<void> {
  return new Promise((resolve, reject) => {
    http
      .delete(`/api/competition/${contestId}/track/${trackId}/team/${teamId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve();
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.info||error.response.data;
          return reject(message);
          if (status === 401) return reject("token-invalid");
          if (status === 403) return reject("unjoined-track");
          if (status === 409) return reject("joined-team");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function updateTeamApplication(
  token: string,
  contestId: number,
  trackId: number,
  teamId: number
): Promise<TeamApplication[]> {
  return new Promise((resolve, reject) => {
    http
      .get(
        `/api/competition/${contestId}/track/${trackId}/team/${teamId}/application`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        return resolve(response.data.data as TeamApplication[]);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.info||error.response.data;
          return reject(message);
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function updateUserApplication(
  token: string,
  contestId: number,
  trackId: number
): Promise<TeamApplication[]> {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/competition/${contestId}/track/${trackId}/application`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data.data as TeamApplication[]);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.info||error.response.data;
          return reject(message);
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function verifyUserApplication(
  token: string,
  contestId: number,
  trackId: number,
  teamId: number,
  applicationId: number,
  status: ValidateApplicationStatus
): Promise<void> {
  return new Promise((resolve, reject) => {
    http
      .put(
        `/api/competition/${contestId}/track/${trackId}/team/${teamId}/application/${applicationId}`,
        { status },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        return resolve();
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.info||error.response.data;
          console.log(message);
          return reject(message);
          if (status === 401) return reject("token-invalid");
          if (status === 403) return reject("already-verified");
          if (status === 409) return reject("user-in-team");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function sendApplication(
  token: string,
  contestId: number,
  trackId: number,
  teamId: number
): Promise<number> {
  return new Promise((resolve, reject) => {
    http
      .post(
        `/api/competition/${contestId}/track/${trackId}/team/${teamId}/join`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        return resolve(response.data.Identity as number);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.info||error.response.data;
          return reject(message);
          if (status === 401) return reject("token-invalid");
          if (status === 403) return reject("already-verified");
          if (status === 409) return reject("user-in-team");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function cancelApplication(
  token: string,
  contestId: number,
  trackId: number,
  appId: number
): Promise<number> {
  return new Promise((resolve, reject) => {
    http
      .put(
        `/api/competition/${contestId}/track/${trackId}/application/${appId}`,
        { status: "canceled" },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        return resolve(response.data.Identity as number);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.info||error.response.data;
          return reject(message);
          if (status === 401) return reject("token-invalid");
          if (status === 403) return reject("already-verified");
          if (status === 409) return reject("user-in-team");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}
export function getTeamAvatarToken(
  token: string,
  contestId: number,
  trackId: number,
  teamId: number
): Promise<AvatarCredentials> {
  return new Promise((resolve, reject) => {
    http
      .get(
        `/api/competition/${contestId}/track/${trackId}/team/${teamId}/avatar`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        return resolve(response.data as AvatarCredentials);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.info||error.response.data;
          return reject(message);
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 403) return reject("password-incorrect");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}
